import type { PayloadAction } from '@reduxjs/toolkit';
import type { ContentReducerCreator } from '../types';
import type { StaticVideo } from '@/types/video.types';

const videoConversionUpdate = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<StaticVideo>) => {
    if (state.uploadedVideos) {
      state.uploadedVideos = state.uploadedVideos.map((vid) =>
        vid.uuid === action.payload.uuid ? action.payload : vid
      );
    }
  });
};

export default videoConversionUpdate;
